<template>
  <div
    v-loading="loding"
    :element-loading-text="language('forgetPassword.placeholder5')"
  >
    <div>
      <!-- <el-card class="login-form" shadow="never"> -->
      <div class="form_wrap" id="form_wrap_changeEmail">
        <el-form
          :model="loginForm"
          :rules="rules"
          status-icon
          ref="ruleForm"
          class="form"
        >
          <el-form-item prop="name">
            <el-input
              v-model="loginForm.name"
              :width="100"
              :placeholder="language('forgetPassword.placeholderLoginName2')"
            >
            </el-input>
          </el-form-item>

          <el-form-item prop="code">
            <el-input
              type="text"
              v-model="loginForm.code"
              :width="100"
              :placeholder="language('forgetPassword.placeholderCode')"
            >
              <div slot="append">
                <el-button
                  type="primary"
                  @click="getCode"
                  v-if="showGetCodebutton"
                  class="getCodeButton"
                  >{{ language("forgetPassword.getCodeText") }}</el-button
                >
                <el-button type="primary" v-if="!showGetCodebutton">{{
                  languageTC("forgetPassword.getCodeText2", timeText)
                }}</el-button>
              </div>
            </el-input>
          </el-form-item>
          <el-form-item prop="captcha" :style="'margin-bottom:'+ (captchaWidth && showCaptcha?'18px':'0px')">
            <div class="captcha_wrap" v-if="captchaWidth && showCaptcha">
              <Captcha
                buttonId="login_button"
                @captchaVerifyCallback="captchaVerifyCallback"
                :captchaWidth="captchaWidth"
              ></Captcha>
            </div>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              style="width: 100%"
              @click="doForgetPassword"
              >{{ language("forgetPassword.submit") }}</el-button
            >
          </el-form-item>
        </el-form>
      </div>
      <!-- </el-card> -->
    </div>
  </div>
</template>

<script>
const checkEmail = require("../rules/checkEmail.js").mixin;
import Captcha from "./Captcha.vue";

export default {
  mixins: [checkEmail],
  components: { Captcha },
  data() {
    return {
      loding: false,
      loginForm: {
        name: "",
        code: "",
      },
      rules: {
        name: [
          {
            required: true,
            message: this.language("forgetPassword.rulesName"),
            trigger: "click",
          },
          { validator: this.checkLoginName, trigger: "blur" },
        ],
        code: [
          {
            required: true,
            message: this.language("forgetPassword.rulesCode"),
            trigger: "click",
          },
        ],
        captcha: [{ validator: this.checkCaptcha, trigger: "blur" }],
      },
      showGetCodebutton: true,
      timeText: 60,
      activeName: "phone",
      verifyResult: {
        captchaResult: false,
        bizResult: "",
      },
      showCaptcha: false,
      captchaWidth: 437,
      timeR:null
    };
  },
  watch: {},
  computed: {
    appTheme: function () {
      return this.$store.state.appData.appTheme;
    },
  },
  methods: {
    checkLoginName(rule, value, callback) {
      let text = "";
      text = this.checkEmail(this.loginForm.name);
      if (text != "") {
        callback(new Error(text));
      } else {
        callback();
      }
    },
    checkCaptcha(rule, value, callback) {
      if (this.verifyResult.captchaResult == false && this.showCaptcha) {
        callback(new Error(this.language("login.captchaText")));
      } else {
        callback();
      }
    },
    getCode() {
      this.$refs.ruleForm.validateField("name", (e) => {
        if (e == "") {
          this.$refs.ruleForm.validateField("captcha", (e2) => {
            if (e2 == "") {
              let data = {};
              data = {
                email: this.loginForm.name,
              };
              if (this.verifyResult.captchaResult == true && this.showCaptcha) {
                data.captcha = this.verifyResult.captcha;
              }
              oauthSDK
                .bindEmailCode(data)
                .then((res) => {
                  this.timeText = 60;
                  this.countTime();
                  this.showGetCodebutton = false;
                  // this.verifyResult = {
                  //   captchaResult: false,
                  //   bizResult: "",
                  // };
                })
                .catch((err) => {
                  // this.defalutToast(err.message);
                  if (err.code == 40003) {
                    this.showCaptcha = true;
                    this.verifyResult = {
                      captchaResult: false,
                      bizResult: "",
                    };
                  } else {
                    this.defalutToast(err.message);
                  }
                  this.loding = false;
                });
            }
          });
        }
      });
    },
    countTime() {
      window.clearInterval(this.timeR);
      this.timeR = setTimeout(() => {
        this.timeText = this.timeText - 1;
        if (this.timeText > 0) {
          this.countTime();
        } else if (this.timeText == 0) {
          this.showGetCodebutton = true;
          window.clearInterval(this.timeR);
        }
      }, 1000);
    },
    doForgetPassword() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          this.loding = true;
          let data = {
            email: this.loginForm.name,
            code: this.loginForm.code,
          };
          oauthSDK
            .bindEmail(data)
            .then((res) => {
              this.loding = false;
              this.$message.success(this.language("userInfo.success"));
              this.$emit("updateUserInfo", true);
            })
            .catch((err) => {
              this.user401(err);
              this.defalutToast(err.message);
              this.loding = false;
            });
        } else {
          return false;
        }
      });
    },
    captchaVerifyCallback(e) {
      this.verifyResult = e;
      this.getCode();
    },
  },
  mounted() {
    setTimeout(() => {
      this.captchaWidth = document.getElementById(
        "form_wrap_changeEmail"
      ).offsetWidth;
    }, 2000);
  },
  created() {},
};
</script>

<style lang="scss"  scoped>
.form_wrap {
  width: 80%;
  margin: 0 auto;
}

.login-form {
  width: 600px;
  height: 390px;
}
</style>